var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxtf-tooltip",
    {
      staticClass: "ellipsis",
      attrs: {
        placement: "top",
        "open-filter": "",
        "popper-options": _vm.popperOptions,
      },
    },
    [
      _c("div", { attrs: { slot: "content" }, slot: "content" }, [
        _c(
          "div",
          { style: { "max-width": _vm.rankWidth + "px" } },
          [
            _vm._l(_vm.codes, function (item, index) {
              return [
                _c("content-name", {
                  key: index,
                  attrs: { code: item, name: _vm.contents[item] },
                }),
                index !== _vm.codes.length - 1 && _vm.codes.length > 1
                  ? _c("span", {
                      key: index,
                      staticClass:
                        "mh8 yxtbiz-rank-list__secondary-content-vertical-bar",
                    })
                  : _vm._e(),
              ]
            }),
          ],
          2
        ),
      ]),
      _c(
        "div",
        { staticClass: "font-size-14 lh20 mt6" },
        [
          _vm._l(_vm.codes, function (item, index) {
            return [
              _c("content-name", {
                key: index,
                attrs: { code: item, name: _vm.contents[item] },
              }),
              index !== _vm.codes.length - 1 && _vm.codes.length > 1
                ? _c("span", {
                    key: index,
                    staticClass:
                      "mh8 yxtbiz-rank-list__secondary-content-vertical-bar",
                  })
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }